// extracted by mini-css-extract-plugin
module.exports = {"user-page-body":"layout_user-page-body__ckcGY","admin-page-body":"layout_admin-page-body__1feMU"};